/* Dansk katalog for locale-advisor-reports-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'adv.cf.cashBasisMissing': 'Likviditetsgrundlaget er ikke tilgængeligt. Saldo og bevægelser skal kunne afstemmes mod hovedbogen.',
  'adv.cf.cashBalanceEvidence': 'Bogført kasse- og banksaldo er {amount}. Dette er ikke en bankbekræftet saldo.',
  'adv.rpt.period.profit': 'I {quarter}. kvartal {year} er indtægterne {income} og overskuddet {result}.',
  'adv.rpt.period.loss': 'I {quarter}. kvartal {year} er indtægterne {income} og underskuddet {result}.',
  'adv.rpt.period.nativeSuppliers': 'Leverandørlisten gælder daterede køb i kvartalet, uden anlægsaktiver og importerede årsopsummeringer uden kvartalsfordeling.',
  'adv.rpt.period.choose': 'Periode',
  'adv.rpt.period.year': 'Hele året',
  'adv.rpt.period.yearLabel': 'Hele {year}',
  'adv.rpt.period.quarter': '{quarter}. kvartal',
  'adv.rpt.period.label': '{quarter}. kvartal {year}',
  'adv.rpt.period.vsQuarter': 'mod samme kvartal året før',
  'adv.rpt.period.quarterBasis': 'Regnskabstal for {from}–{to}. Balancen viser saldo ved periodens udgang.',
  'adv.rpt.period.currentStatus': 'Opfølgningsstatus ved rapportgenerering {date}. Denne del bruger dagens åbne poster og årsoversigt, ikke historisk status ved kvartalets udgang.',
  'adv.rpt.period.rolling': 'Rullende 12 måneder frem til {to}, sammenlignet med de foregående 12 måneder.',
  'adv.rpt.period.nativeSales': 'Kunde- og fakturadetaljer gælder bogførte fakturaer dateret i kvartalet. Importerede årsopsummeringer uden kvartalsfordeling er ikke med her.',
  'adv.rpt.period.budget': 'Bogført i det valgte kvartal sammenlignes med budgettet for de samme tre måneder.',
  'adv.rpt.period.pdfUnavailable': 'Det nye PDF-layout er ikke tilgængeligt på serveren endnu. Prøv igen efter opdateringen.',
  'adv.rpt.slides.present': 'Præsenter',
  'adv.rpt.slides.exit': 'Afslut præsentation',
  'adv.rpt.slides.readable': 'Læs sidens tekst',
  'adv.rpt.slides.previous': 'Tilbage',
  'adv.rpt.slides.next': 'Næste',
  'adv.rpt.slides.page': 'Side {current} af {total}',
  'adv.rpt.modal.title': 'Lav rapport',
  'adv.rpt.modal.intro': 'Vælg en rapportskabelon. SuperPlumma henter tallene fra dit regnskab og sammensætter et udkast, du kan gennemgå, før det deles.',
  'adv.rpt.modal.generate': 'Generer rapport',
  'adv.rpt.modal.cancel': 'Annuller',
  'adv.rpt.modal.basis': 'Datagrundlag: {sources}',
  'adv.rpt.modal.year': 'Regnskabsår',
  'adv.rpt.modal.saved': 'Gemte rapporter',
  'adv.rpt.modal.savedEmpty': 'Du har ingen gemte rapporter endnu.',
  'adv.rpt.modal.open': 'Åbn',
  'adv.rpt.modal.delete': 'Slet',
  'adv.rpt.modal.deleted': 'Rapporten er slettet.',
  'adv.rpt.hero.cta': 'Lav rapport',
  'adv.rpt.saved.title': 'Gemte rapporter',
  'adv.rpt.saved.tab': 'Gemte rapporter',
  'adv.rpt.saved.description': 'Rapporter, du gemmer, bliver liggende som øjebliksbilleder og ændres ikke, når regnskabet opdateres.',
  'adv.rpt.saved.count': '{count} af {limit} rapporter gemt',
  'adv.rpt.saved.limitError': 'Du kan højst gemme {limit} rapporter. Slet en rapport, før du gemmer en ny.',
  'adv.rpt.saved.loading': 'Henter gemte rapporter …',
  'adv.rpt.saved.emptyTitle': 'Ingen gemte rapporter',
  'adv.rpt.saved.emptyText': 'Lav en rapport, og gem den, når du vil beholde netop denne version.',
  'adv.rpt.saved.loadFailed': 'Kunne ikke hente gemte rapporter.',
  'adv.rpt.saved.deleteFailed': 'Kunne ikke slette rapporten.',
  'adv.rpt.tpl.styre.name': 'Bestyrelses- og ledelsesrapport',
  'adv.rpt.tpl.styre.desc': 'Samlet rapport til bestyrelsen med resultat, likviditet, risiko og anbefalede tiltag.',
  'adv.rpt.tpl.manedsrapport.name': 'Månedsrapport',
  'adv.rpt.tpl.manedsrapport.desc': 'Status for den valgte måned med budget, sammenligning med sidste år, trend og anbefalede næste skridt.',
  'adv.rpt.tpl.likviditet.name': 'Likviditetsrapport',
  'adv.rpt.tpl.likviditet.desc': 'Åbne poster, buffer og løbende saldo baseret på bogførte tal.',
  'adv.rpt.tpl.avvik.name': 'Resultat- og afvigelsesrapport',
  'adv.rpt.tpl.avvik.desc': 'De største afvigelser fra budgettet år til dato og de omkostningslinjer, der har ændret sig mest.',
  'adv.rpt.tpl.kunde.name': 'Kunde- og salgsrapport',
  'adv.rpt.tpl.kunde.desc': 'Salgsudvikling, største kunder, kundekoncentration og udestående.',
  'adv.rpt.tpl.kostnad.name': 'Omkostningsrapport',
  'adv.rpt.tpl.kostnad.desc': 'Omkostningsudvikling, de største leverandører og bilag, der mangler dokumentation.',
  'adv.rpt.tpl.utestaende.name': 'Udestående poster',
  'adv.rpt.tpl.utestaende.desc': 'Ubetalte kunde- og leverandørposter fordelt på forfaldne og ikke forfaldne.',
  'adv.rpt.tpl.arsoppsummering.name': 'Årsopsummering',
  'adv.rpt.tpl.arsoppsummering.desc': 'Opsummerer hele året — resultat, balance, salg, omkostninger og risiko.',
  'adv.rpt.length.2to3': '2–3 sider',
  'adv.rpt.length.2to4': '2–4 sider',
  'adv.rpt.length.3to5': '3–5 sider',
  'adv.rpt.length.4to6': '4–6 sider',
  'adv.rpt.length.8to12': '8–12 sider',
  'adv.rpt.length.variable': 'Omfanget følger datagrundlaget',
  'adv.rpt.length.10to14': '10–14 sider',
  'adv.rpt.doc.contents': 'Indhold',
  'adv.rpt.doc.brand': 'PLUMME / AI-RÅDGIVER',
  'adv.rpt.doc.continued': 'forts.',
  'adv.rpt.doc.back': 'Tilbage',
  'adv.rpt.doc.draft': 'Udkast',
  'adv.rpt.doc.saved': 'Gemt',
  'adv.rpt.doc.save': 'Gem',
  'adv.rpt.doc.savedToast': 'Rapporten er gemt.',
  'adv.rpt.doc.exportPdf': 'Eksporter PDF',
  'adv.rpt.doc.exportPptx': 'Download PowerPoint',
  'adv.rpt.doc.exportingPptx': 'Bygger PowerPoint …',
  'adv.rpt.doc.exportPptxFailed': 'Kunne ikke lave PowerPoint-filen. Prøv igen.',
  'adv.rpt.doc.presentation': 'PRÆSENTATION',
  'adv.rpt.doc.coverFoot': 'Genereret fra rapportgrundlaget i Plumme',
  'adv.rpt.doc.exporting': 'Laver PDF …',
  'adv.rpt.doc.exportFailed': 'Kunne ikke lave rapportfilen. Prøv igen.',
  'adv.rpt.doc.period': '{year} · {months} måneder af året',
  'adv.rpt.doc.createTask': 'Opret opgave',
  'adv.rpt.doc.taskCreated': 'Lagt i handlingscentret med opfølgning {date}.',
  'adv.rpt.doc.taskFailed': 'Kunne ikke oprette opgaven.',
  'adv.rpt.doc.taskNote': 'Oprettet fra {report}.',
  'adv.rpt.narr.section': 'Sammendrag fra SuperPlumma',
  'adv.rpt.narr.tag': 'Skrevet af SuperPlumma',
  'adv.rpt.narr.idle': 'Lad SuperPlumma læse rapporten og skrive sammendraget: hvad der står på spil, hvad der faktisk flyttede sig, og hvad du bør gøre nu.',
  'adv.rpt.narr.write': 'Skriv sammendrag',
  'adv.rpt.narr.rewrite': 'Skriv igen',
  'adv.rpt.narr.loading': 'SuperPlumma læser rapporten …',
  'adv.rpt.narr.failed': 'Kunne ikke skrive sammendraget. Tallene i rapporten er under alle omstændigheder komplette.',
  'adv.rpt.narr.drivers': 'Dette flyttede sig',
  'adv.rpt.narr.watch': 'Dette bør følges',
  'adv.rpt.narr.nextStep': 'Næste skridt: ',
  'adv.rpt.narr.foot': 'Sammendraget er skrevet ud fra tallene i rapporten. Alle beløb er kontrolleret mod rapporten, før teksten vises.',
  'adv.rpt.sec.changeSince': 'Ændringer siden forrige rapport',
  'adv.rpt.col.lastReport': 'Forrige rapport',
  'adv.rpt.col.now': 'Nu',
  'adv.rpt.col.change': 'Ændring',
  'adv.rpt.note.changeSinceBasis': 'Sammenlignet med rapporten, der blev gemt {date}. Tallene der er et øjebliksbillede og ændrer sig ikke efterfølgende.',
  'adv.rpt.empty.noPreviousReport': 'Dette er den første gemte rapport af denne type for året. Næste gang viser denne sektion, hvad der er ændret siden nu.',
  'adv.rpt.empty.noComparableReport': 'Forrige rapport har ingen nøgletal at sammenligne med.',
  'adv.rpt.sec.summary': 'Sammendrag',
  'adv.rpt.sec.events': 'Væsentlige hændelser',
  'adv.rpt.sec.keyFigures': 'Økonomiske nøgletal',
  'adv.rpt.sec.budget': 'Resultat mod budget',
  'adv.rpt.sec.liquidity': 'Likviditet og betalingsforpligtelser',
  'adv.rpt.sec.forecast': 'Løbende saldo gennem året',
  'adv.rpt.sec.balance': 'Balance og soliditet',
  'adv.rpt.sec.resultTrend': 'Resultatudvikling',
  'adv.rpt.sec.sales': 'Salg og kundeudvikling',
  'adv.rpt.sec.customerChange': 'Kundeloyalitet og betalingstid',
  'adv.rpt.sec.costTrend': 'Omkostningsudvikling',
  'adv.rpt.sec.suppliers': 'Største leverandører',
  'adv.rpt.sec.voucherReview': 'Bilag til gennemgang',
  'adv.rpt.sec.receivables': 'Kundeposter',
  'adv.rpt.sec.payables': 'Leverandørposter',
  'adv.rpt.sec.risk': 'Risiko og usikkerhed',
  'adv.rpt.sec.actions': 'Anbefalede tiltag',
  'adv.rpt.sec.decisions': 'Sager til beslutning',
  'adv.rpt.sec.dataBasis': 'Datagrundlag',
  'adv.rpt.sec.bridge': 'Hvad flyttede resultatet',
  'adv.rpt.sec.workingCapital': 'Arbejdskapital og bindingstid',
  'adv.rpt.sec.rolling': 'Rullende 12 måneder',
  'adv.rpt.col.driver': 'Drivkraft',
  'adv.rpt.col.effect': 'Effekt',
  'adv.rpt.col.priority': 'Prioritet',
  'adv.rpt.bridge.opening': 'Resultat {year}',
  'adv.rpt.bridge.closing': 'Resultat {year}',
  'adv.rpt.bridge.revenue': 'Ændring i indtægter',
  'adv.rpt.bridge.finance': 'Ændring i finansielle poster',
  'adv.rpt.bridge.other': 'Øvrige poster ({count} linjer)',
  'adv.rpt.bridge.readGuide': 'Læs fra venstre: Start med sidste års resultat. Grønt løfter resultatet, rødt trækker det ned. Sidste søjle er årets resultat. Beløbene nedenfor viser hvert bidrag.',
  'adv.rpt.bridge.readShort': 'Fra sidste år til i år · Grønt løfter resultatet · Rødt trækker ned',
  'adv.rpt.note.bridgeBasis': 'Linjer med en effekt under {amount} er slået sammen. Broen går fra resultatet i {year} til resultatet i år, og summen af driverne er hele ændringen.',
  'adv.rpt.empty.noBridgeBasis': 'Uden bogførte tal for {year} kan ændringen ikke brydes ned på drivere.',
  'adv.rpt.empty.noBridgeChange': 'Resultatet er uændret fra {year}.',
  'adv.rpt.metric.receivableDays': 'Tilgodehavender fra kunder',
  'adv.rpt.metric.payableDays': 'Leverandørgæld',
  'adv.rpt.metric.capitalGap': 'Bindingstid netto',
  'adv.rpt.metric.measuredPaymentDays': 'Faktisk betalingstid',
  'adv.rpt.metric.netCapitalTied': 'Netto bundet kapital',
  'adv.rpt.note.capitalGapPositive': 'Du venter {days} dage længere på pengene, end du selv bruger på at betale. Det er den periode, driften skal finansieres af egen kasse.',
  'adv.rpt.note.capitalGapNegative': 'Du betaler senere, end du får betalt. Leverandørkreditten finansierer da en del af driften.',
  'adv.rpt.note.capitalGapUnknown': 'Netto bindingstid kan ikke beregnes, fordi indtægts- eller omkostningsgrundlaget mangler.',
  'adv.rpt.note.workingCapitalBasis': 'Tilgodehavende- og leverandørdagene er skøn baseret på åbne poster og {months} måneder af regnskabsåret. Faktisk betalingstid måles kun på betalte kundefakturaer og er derfor ikke samme beregning.',
  'adv.rpt.empty.noWorkingCapital': 'Ingen åbne kunde- eller leverandørposter at måle bindingstid på.',
  'adv.rpt.cell.vsPrevious12': 'mod forrige 12',
  'adv.rpt.note.rollingBasis': 'Vinduet er de seneste {months} bogførte måneder, så sammenligningen krydser årsskiftet og påvirkes ikke af sæson.',
  'adv.rpt.note.noRollingComparison': 'Der er ikke nok historik til at sammenligne med de foregående 12 måneder.',
  'adv.rpt.empty.noRollingBasis': 'For lidt bogført historik til at bygge et rullende 12-månedersvindue.',
  'adv.rpt.certainty.planned': 'Planlagt',
  'adv.rpt.summary.profit': 'Efter {months} måneder af {year} er der bogført {income} i indtægter og et overskud på {result}.',
  'adv.rpt.summary.loss': 'Efter {months} måneder af {year} er der bogført {income} i indtægter og et underskud på {result}.',
  'adv.rpt.summary.margin': 'Det giver en overskudsgrad på {margin} %.',
  'adv.rpt.kpi.income': 'Indtægter',
  'adv.rpt.kpi.costs': 'Omkostninger',
  'adv.rpt.kpi.result': 'Resultat',
  'adv.rpt.kpi.margin': 'Overskudsgrad',
  'adv.rpt.kpi.revenue': 'Faktureret salg',
  'adv.rpt.kpi.invoiceCount': 'Antal fakturaer',
  'adv.rpt.kpi.avgInvoice': 'Gennemsnit pr. faktura',
  'adv.rpt.kpi.customerCount': 'Antal kunder',
  'adv.rpt.metric.receivables': 'Udestående fra kunder',
  'adv.rpt.metric.payables': 'Skyldig til leverandører',
  'adv.rpt.metric.buffer': 'Likviditetsbuffer',
  'adv.rpt.metric.lowestBalance': 'Laveste saldo i året',
  'adv.rpt.metric.assets': 'Aktiver i alt',
  'adv.rpt.metric.equityAndDebt': 'Egenkapital og gæld i alt',
  'adv.rpt.metric.solidity': 'Soliditetsgrad',
  'adv.rpt.metric.repeatRate': 'Andel genkøbskunder',
  'adv.rpt.metric.avgPaymentDays': 'Gns. betalingstid',
  'adv.rpt.unit.days': '{days} dage',
  'adv.rpt.col.line': 'Linje',
  'adv.rpt.col.account': 'Konto',
  'adv.rpt.col.budgetToDate': 'Budget til dato',
  'adv.rpt.col.actual': 'Bogført',
  'adv.rpt.col.variance': 'Afvigelse',
  'adv.rpt.col.month': 'Måned',
  'adv.rpt.col.in': 'Ind',
  'adv.rpt.col.out': 'Ud',
  'adv.rpt.col.balance': 'Saldo',
  'adv.rpt.col.certainty': 'Grundlag',
  'adv.rpt.col.income': 'Indtægter',
  'adv.rpt.col.costs': 'Omkostninger',
  'adv.rpt.col.result': 'Resultat',
  'adv.rpt.col.share': 'Andel',
  'adv.rpt.chart.budgetActual': 'Budget mod bogført til dato',
  'adv.rpt.chart.monthlyResult': 'Resultat pr. måned',
  'adv.rpt.chart.incomeCosts': 'Indtægter og omkostninger pr. måned',
  'adv.rpt.chart.summaryResult': 'Fra indtægter til resultat',
  'adv.rpt.chart.keyFiguresComparison': 'Hovedtal mod sidste år',
  'adv.rpt.chart.previousPeriod': 'Forrige periode',
  'adv.rpt.chart.currentPeriod': 'Denne periode',
  'adv.rpt.chart.cumulativeResult': 'Akkumuleret resultat gennem året',
  'adv.rpt.chart.runningBalance': 'Løbende saldo og likviditetsbuffer',
  'adv.rpt.chart.openItemsDue': 'Åbne poster efter forfald',
  'adv.rpt.chart.workingCapitalGap': 'Kapital bundet i åbne poster',
  'adv.rpt.chart.balanceBasis': 'Bogførte balancegrupper',
  'adv.rpt.chart.bookedBalance': 'Bogført saldo',
  'adv.rpt.chart.capitalStructure': 'Kapitalstruktur',
  'adv.rpt.chart.equityShare': 'Egenkapital',
  'adv.rpt.chart.otherFinancing': 'Anden finansiering',
  'adv.rpt.chart.profit': 'Overskud',
  'adv.rpt.chart.loss': 'Underskud',
  'adv.rpt.col.amount': 'Beløb',
  'adv.rpt.col.changeYoy': 'Ændring mod sidste år',
  'adv.rpt.col.status': 'Status',
  'adv.rpt.row.income': 'Indtægter',
  'adv.rpt.row.costs': 'Omkostninger',
  'adv.rpt.row.notDue': 'Ikke forfaldet',
  'adv.rpt.row.current': 'Ikke forfaldet',
  'adv.rpt.row.overdue': 'Forfaldet',
  'adv.rpt.row.total': 'I alt',
  'adv.rpt.cell.vsPreviousYear': 'mod sidste år',
  'adv.rpt.cell.noBasis': 'Ingen sammenligning',
  'adv.rpt.month.jan': 'Januar',
  'adv.rpt.month.feb': 'Februar',
  'adv.rpt.month.mar': 'Marts',
  'adv.rpt.month.apr': 'April',
  'adv.rpt.month.may': 'Maj',
  'adv.rpt.month.jun': 'Juni',
  'adv.rpt.month.jul': 'Juli',
  'adv.rpt.month.aug': 'August',
  'adv.rpt.month.sep': 'September',
  'adv.rpt.month.oct': 'Oktober',
  'adv.rpt.month.nov': 'November',
  'adv.rpt.month.dec': 'December',
  'adv.rpt.certainty.confirmed': 'Bogført',
  'adv.rpt.certainty.expected': 'Indeværende måned',
  'adv.rpt.certainty.uncertain': 'Ikke bogført endnu',
  'adv.rpt.budget.intro': 'Bogførte tal for {months} måneder af {year} er sammenlignet med budgettet for de samme måneder, ikke med hele årets budget.',
  'adv.rpt.vouchers.missing': '{count} bogførte køb mangler bilag. Samlet drejer det sig om {net} i grundlag og {vat} i fradragsført moms.',
  'adv.rpt.action.impact': '{label}: {value}',
  'adv.rpt.priority.high': 'Høj',
  'adv.rpt.priority.medium': 'Middel',
  'adv.rpt.priority.low': 'Lav',
  'adv.rpt.severity.critical': 'Kritisk',
  'adv.rpt.severity.watch': 'Bør følges op',
  'adv.rpt.severity.info': 'Til orientering',
  'adv.rpt.decision.risk': 'Tag stilling til: {name}',
  'adv.rpt.decision.opportunity': 'Overvej: {name}',
  'adv.rpt.decision.freeCapital': 'Beslut, hvordan ledig kapital på {amount} skal bruges.',
  'adv.rpt.note.noPreviousYear': 'Der er ingen bogførte tal for {year}, så ændringen mod sidste år kan ikke beregnes.',
  'adv.rpt.note.partialYear': 'Perioden er ikke afsluttet. Tallene dækker {months} måneder af {year}.',
  'adv.rpt.note.noMaterialVariance': 'Ingen enkeltlinjer afviger væsentligt fra budgettet.',
  'adv.rpt.note.unbudgeted': '{count} konti har bogførte beløb uden budgetlinje. De er medtaget i totalen.',
  'adv.rpt.note.belowBuffer': 'Laveste beregnede saldo er {lowest}, under det valgte buffermål på {buffer}.',
  'adv.rpt.note.aboveBuffer': 'Den løbende saldo holder sig over bufferen på {buffer} i hele perioden.',
  'adv.rpt.note.forecastIsBooked': 'Kurven er en løbende saldo af bogførte tal, ikke en prognosemodel. Måneder, der endnu ikke er bogført på, står fladt.',
  'adv.rpt.note.balanceGrouping': 'Egenkapital og gæld vises samlet, sådan som saldobalancen grupperer dem.',
  'adv.rpt.note.balanceInterimBasis': 'Balancegrupperne vises, som de er bogført på rapportdatoen. Forskellen mellem siderne kan omfatte periodens resultat og skal ikke læses som en færdig årsbalance.',
  'adv.rpt.note.noCustomerSplit': 'Salget er ikke fordelt pr. kunde i grundlaget.',
  'adv.rpt.note.concentration': '{name} står for {pct} % af det fakturerede salg.',
  'adv.rpt.note.customerBasis': 'Betalingstiden er målt på fakturaer, der faktisk er betalt.',
  'adv.rpt.note.costJump': 'En eller flere omkostningslinjer er steget mere end 25 % i forhold til sidste år.',
  'adv.rpt.note.topFiveOnly': 'Viser de fem største. Resten indgår i totalerne, men vises ikke.',
  'adv.rpt.note.vouchersComplete': 'Alle bogførte køb har bilag.',
  'adv.rpt.note.vouchersRequired': 'Bokføringsloven kræver dokumentation for hver postering. Manglende bilag bør fremskaffes, før perioden indberettes.',
  'adv.rpt.note.overdueSales': '{amount} er forfaldet fra kunder og bør følges op.',
  'adv.rpt.note.overduePurchases': '{amount} er forfaldet til leverandører.',
  'adv.rpt.note.noRisks': 'Der er ikke fundet risikoforhold i de bogførte tal.',
  'adv.rpt.note.noActions': 'Ingen tiltag anbefales lige nu.',
  'adv.rpt.note.notAProtocol': 'Dette er beslutningsstøtte og erstatter ikke en bestyrelsesprotokol. Beslutninger træffes af bestyrelsen.',
  'adv.rpt.empty.noBookkeeping': 'Der er ikke bogført indtægter eller omkostninger for {year}. Rapporten får tal, så snart der er bilag.',
  'adv.rpt.empty.noEvents': 'Der er ikke registreret væsentlige ændringer i perioden.',
  'adv.rpt.empty.noBudget': 'Der findes intet budget for {year}. Indtast et budget for at få afvigelser i rapporten.',
  'adv.rpt.empty.noLiquidityBasis': 'Ingen åbne kunde- eller leverandørposter og ingen bogførte bevægelser at bygge saldoen på.',
  'adv.rpt.empty.noForecast': 'Der findes ikke et afstemt likviditetsgrundlag for saldokurven.',
  'adv.rpt.empty.noBalance': 'Saldobalancen for {year} er tom.',
  'adv.rpt.empty.noSales': 'Der er ikke bogført faktureret salg for {year}.',
  'adv.rpt.empty.noCustomerHistory': 'For lidt kundehistorik til at måle genkøb og betalingstid.',
  'adv.rpt.empty.noCosts': 'Der er ikke bogført omkostninger for {year}.',
  'adv.rpt.empty.noSupplierSplit': 'Omkostningerne er ikke fordelt pr. leverandør i grundlaget.',
  'adv.rpt.empty.noReceivables': 'Ingen udestående kundeposter.',
  'adv.rpt.empty.noPayables': 'Ingen udestående leverandørposter.',
  'adv.rpt.empty.noDecisions': 'Ingen sager kræver beslutning lige nu.',
  'adv.rpt.source.result': 'Resultatopgørelse',
  'adv.rpt.source.balance': 'Saldobalance',
  'adv.rpt.source.openItems': 'Åbne kunde- og leverandørposter',
  'adv.rpt.source.budget': 'Budget',
  'adv.rpt.source.bank': 'Bankbevægelser',
  'adv.rpt.source.invoices': 'Kundefakturaer',
  'adv.rpt.source.purchases': 'Leverandørfakturaer',
  'adv.rpt.source.vouchers': 'Bilag',
  'adv.rpt.basis.generated': 'Genereret {date}.',
  'adv.rpt.basis.period': 'Perioden dækker {months} måneder af {year}.',
  'adv.rpt.basis.noPreviousYear': 'Ingen bogførte tal for {year} — sammenligning med sidste år mangler.',
  'adv.rpt.basis.noBudget': 'Ingen budgetlinjer for {year}.',
  'adv.rpt.basis.noPartySplit': 'Fordelingen pr. kunde og leverandør er ufuldstændig. Kundeoversigten viser det, der kan spores til faktureret salg.',
  'adv.rpt.basis.topFive': 'Kunde- og leverandørlister viser de fem største.',
  'adv.rpt.basis.bookedOnly': 'Regnskabstal kommer fra bogføringen. Buffer er et mål, ikke en bogført saldo. Planlagte betalinger og beregnede nøgletal er markeret i rapporten.',
  'adv.rpt.period.monthShort': '{month}/{year}',
  'adv.rpt.period.vsPreviousMonth': 'i forhold til forrige måned',
  'adv.rpt.monthPicker.title': 'Vælg måned for månedsrapporten',
  'adv.rpt.monthPicker.intro': 'Vælg en af de seneste 24 kalendermåneder. Rapporten bruger kun bogførte tal, budget og sammenligninger for den valgte måned.',
  'adv.rpt.monthPicker.separate': 'Månedsrapporten har sit eget månedsvalg og påvirkes ikke af års- eller kvartalsvalget for andre rapporter.',
  'adv.rpt.monthPicker.continue': 'Vælg måned',
  'adv.rpt.monthPicker.back': 'Tilbage til rapportskabeloner',
  'adv.rpt.monthPicker.generate': 'Generér månedsrapport',
  'adv.rpt.sec.monthlyStatus': 'Status for måneden',
  'adv.rpt.sec.monthlyBudget': 'Måneden mod budget',
  'adv.rpt.sec.monthlyComparison': 'Samme måned sidste år',
  'adv.rpt.sec.monthlyTrend': 'Udvikling de seneste 12 måneder',
  'adv.rpt.sec.monthlyInsights': 'Månedens vurdering og næste skridt',
  'adv.rpt.empty.noMonthlyBudget': 'Der findes intet budget for den valgte måned.',
  'adv.rpt.empty.noMonthlyComparison': 'Der findes ikke bogførte tal for samme måned sidste år.',
  'adv.rpt.empty.noMonthlyTrend': 'Der findes ikke bogførte månedstal i tolvmånedersvinduet.',
  'adv.rpt.col.budget': 'Budget',
  'adv.rpt.col.variancePct': 'Afvigelse i %',
  'adv.rpt.row.result': 'Resultat',
  'adv.rpt.chart.monthBudgetActual': 'Budget og faktisk for måneden',
  'adv.rpt.chart.sameMonthComparison': 'Valgt måned mod samme måned sidste år',
  'adv.rpt.metric.averageMonthlyResult': 'Gennemsnitligt resultat pr. måned',
  'adv.rpt.metric.bestMonthlyResult': 'Bedste måned',
  'adv.rpt.metric.weakestMonthlyResult': 'Svageste måned',
  'adv.rpt.monthly.statusProfit': 'Måneden endte med et overskud på {result} og en overskudsgrad på {margin} %.',
  'adv.rpt.monthly.statusLoss': 'Måneden endte med et underskud på {result} og en overskudsgrad på {margin} %.',
  'adv.rpt.monthly.budgetAbove': 'Resultatet er {amount} bedre end budgettet for måneden.',
  'adv.rpt.monthly.budgetBelow': 'Resultatet er {amount} svagere end budgettet for måneden.',
  'adv.rpt.monthly.marginChange': 'Overskudsgraden er ændret med {change} procentpoint i forhold til samme måned sidste år.',
  'adv.rpt.monthly.trendBasis': 'Udviklingen viser op til 12 bogførte kalendermåneder frem til og med den valgte måned.',
  'adv.rpt.monthly.insightLossTitle': 'Negativt månedsresultat',
  'adv.rpt.monthly.insightLossBody': 'Omkostningerne var {amount} højere end indtægterne i den valgte måned.',
  'adv.rpt.monthly.insightProfitTitle': 'Positivt månedsresultat',
  'adv.rpt.monthly.insightProfitBody': 'Måneden gav et overskud på {amount}. Følg op på, hvilke indtægter og omkostninger der bør gentages.',
  'adv.rpt.monthly.insightIncomeDownTitle': 'Lavere indtægter end sidste år',
  'adv.rpt.monthly.insightIncomeDownBody': 'Indtægterne er {change} % lavere end samme måned sidste år.',
  'adv.rpt.monthly.insightCostsTitle': 'Omkostninger over budget',
  'adv.rpt.monthly.insightCostsBody': 'Omkostningerne er {amount} højere end budgettet for måneden.',
  'adv.rpt.monthly.insightBudgetTitle': 'Resultat under budget',
  'adv.rpt.monthly.insightBudgetBody': 'Resultatet er {amount} svagere end budgettet for måneden.',
  'adv.rpt.monthly.stepReviewDrivers': 'Gennemgå de poster, der forklarer månedsresultatet, og afklar, hvad der er varigt.',
  'adv.rpt.monthly.stepRevenue': 'Følg op på indtægtsfaldet i forhold til samme måned sidste år.',
  'adv.rpt.monthly.stepCosts': 'Identificér de omkostninger, der ligger over månedsbudgettet.',
  'adv.rpt.monthly.stepBudget': 'Opdatér tiltagene for at lukke resultatafvigelsen mod månedsbudgettet.',
  'adv.rpt.monthly.stepContinue': 'Fasthold drivkræfterne bag det positive månedsresultat, og følg udviklingen næste måned.',
});
